import {
  useMutation,
  type MutationHookOptions,
  type MutationTuple,
  type TypedDocumentNode,
} from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { ReorderLayoutDocument, UpdateLayoutDocument } from './update.generated';

const useUpdate = <T, U>(
  document: TypedDocumentNode<T, U>,
  options: MutationHookOptions<T, U>,
): MutationTuple<T, U> => {
  const { t } = useTranslation();
  return useMutation(document, {
    ...useNotifications(document, {
      failure: t('api.layouts.update_error'),
      success: t('api.layouts.update_success'),
    }),
    ...options,
  });
};

export const useUpdateLayout = (options: ApiOptions<typeof UpdateLayoutDocument> = {}) =>
  useUpdate(UpdateLayoutDocument, options);

export const useReorderLayout = (options: ApiOptions<typeof ReorderLayoutDocument> = {}) =>
  useUpdate(ReorderLayoutDocument, options);
